import type { QuoteListQueryKey, UseQuoteListParams } from '../types';

export const getQuoteListQueryKeyPrefix = () => ['quotes', 'quoteList'];

export const getQuoteListQueryKey = (
  params: UseQuoteListParams,
): QuoteListQueryKey => [...getQuoteListQueryKeyPrefix(), params];
